import { birdify } from './birdify/app';
import { numbcrunch } from './numbcrunch/app';
import { qrCode } from './qr-code/app';

export const apps = [birdify, numbcrunch, qrCode];
